//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AngleTolerance",1,0],[0,"BaseCurve",1,"Section",0],[1,"BendCurve",0,"Section",0],[0,"BendFaces",1,"ScCollector",0],[0,"ControlCurve",1,"Section",0],[0,"DistanceTolerance",1,0],[0,"FirstRegionLimitCurve",1,"Section",0],[0,"FirstRegionOffsetCurve",1,"ScCollector",0],[1,"FirstTargetCurve",0,"ScCollector",0],[1,"FirstTargetCurveOffset",0,"Expression",0],[0,"IterationCount",1,0],[0,"KeepBaseLength",1,0],[0,"ModifyInputSheet",1,0],[1,"RadiusReductionPercent",0,"Expression",0],[1,"RegionToDeformOffset",0,"Expression",0],[1,"RotationAngle",0,"Expression",0],[0,"RotationAngleReverseDirection",1,0],[1,"RotationDistance",0,"Expression",0],[1,"RotationTargetCurve",0,"Section",0],[0,"SecondRegionLimitCurve",1,"Section",0],[0,"SecondRegionOffsetCurve",1,"ScCollector",0],[1,"SecondTargetCurve",0,"ScCollector",0],[1,"SecondTargetCurveOffset",0,"Expression",0],[0,"SheetToDeform",1,"ScCollector",0],[0,"StartLocation",1,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"StretchDirection",1,"Direction",0],[1,"TaperEnd",0,"Expression",0],[1,"TaperStart",0,"Expression",0],[1,"TargetCurve",0,"Section",0],[1,"TargetCurveOffset",0,"Expression",0],[0,"TargetCurveOffsetType",1,0],[0,"TargetPoint",1,"Point",0],[1,"TargetPointOffset",0,"Expression",0],[1,"TargetSheet",0,"ScCollector",0],[0,"TransitionOptions",1,0],[0,"TransitionShapeControl",1,0],[0,"UnformType",1,0]],[[[],"CreatePreviewFacets",{},0,0]],[]];
SPLM.Tooling.FreeformUnformBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.FreeformUnformBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.FreeformUnformBuilder.UnformTypes = Object.freeze({
    "ByCurve" : "ByCurve", "OverBend" : "OverBend"});

SPLM.Tooling.FreeformUnformBuilder.RotationMethodType = Object.freeze({
    "Angle" : "Angle", "Distance" : "Distance"});

SPLM.Tooling.FreeformUnformBuilder.RotationMethod = Object.freeze({
    "Constant" : "Constant", "LawControlled" : "LawControlled", "CurveDefined" : "CurveDefined"});

SPLM.Tooling.FreeformUnformBuilder.DirectionMethodType = Object.freeze({
    "SameAsProjection" : "SameAsProjection", "NormalToSheet" : "NormalToSheet", "NormalToBase" : "NormalToBase", "NormalToControl" : "NormalToControl", "SpecifiedDirection" : "SpecifiedDirection", "None" : "None"});

SPLM.Tooling.FreeformUnformBuilder.DeformBodyType = Object.freeze({
    "SheetBodies" : "SheetBodies", "FacetBodies" : "FacetBodies"});

export default SPLM;